import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { UserService } from './user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  title = 'ADMIN PANEL';

  constructor(
    private afAuth: AngularFireAuth,
    public router: Router,
    private userService: UserService,
  ) {}


  navbarOpen = false;

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  logout() {
    this.userService.clear();
    this.afAuth.auth.signOut();

    // this.ngZone.run( () => {
    this.router.navigateByUrl('/login');
    // });

  }

  isLoggedin() {
    return this.userService.isLoggedIn();
  }


}
